import React from 'react';
import renderRichText from '../../utils/renderRichText';
import './styles.scss';

const Card = ({ content }) => {
  if (!content) return null;

  const articleContent = JSON.parse(content.articleContent.raw);

  return (
    <div className="card publication-card">
      <div className="card-content">
        <div className="content">{renderRichText(articleContent)}</div>
      </div>
    </div>
  );
};

export const Publications = ({ allContentfulPub }) => {
  if (!allContentfulPub) return null;

  return (
    <div id="Publications" className="anchor-intro">
      <h2 className="is-size-2 has-text-centered has-text-weight-bold">
        Publications
      </h2>
      <div className="publications-list">
        {[...allContentfulPub.nodes].map((content, i) => (
          <Card key={i} content={content} />
        ))}
      </div>
    </div>
  );
};
